
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import CommonLink from '@Components/common/Link';
import ProfileLayout from '@Components/Layout/profile';
import { Wrapper } from '@Components/ProfilePage/ProfilePage.styled';
import { Info, Link, P, Title } from '@Components/TermsAndConditions/TermsAndConditions.styled';
import useTranslation from 'next-translate/useTranslation';

type Props = {};

const ContactUs = ({}: Props) => {
  const { t } = useTranslation('common');
  return (
    <ProfileLayout seoData={{ title: t('contact_us') }} hideSideBar={true}>
      <Wrapper>
        <div dir="auto">
          <Title>تواصل معنا</Title>
          <Info>إذا كان لديك أي أسئلة بخصوص سياستنا يمكنك التواصل معنا عبر</Info>
          <P>يورباريتس هوا أكبر سوق الكتروني في مصر لكل ما تحتاجه سيارتك </P>
          <Title>
            البريد الالكتروني <Link href="mailto:info@yourparts.com">info@yourparts.com</Link>
          </Title>
          <Title>
            زيارة صفحتنا{' '}
            <Link as={CommonLink} href="/contact">
              yourparts.com/contact
            </Link>
            <Title>
              الخط الساخن{' '}
              <Link href="tel:15145">
                <span>15145</span>
              </Link>
            </Title>
          </Title>
        </div>
      </Wrapper>
    </ProfileLayout>
  );
};

 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default ContactUs;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/contact',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  